import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'singleton',
  standalone: true,
})
export class SingletonPipe implements PipeTransform {
  transform<A>(a: A): A[] {
    if (!a) {
      return [];
    }
    return [a];
  }
}
